import { FC } from 'react';
import { SkeletonWrapper } from '~/skeleton/common/skeleton-wrapper';
import { SkeletonScanline } from '~/skeleton/common/skeleton-scanline';
import { HashtagInfoSkeleton } from '~/skeleton/hashtag/component';
import { ArticleCardSkeleton } from '~/skeleton/common/article-card';

export const HashtagSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <HashtagInfoSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};

export const HashtagBodySkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <ArticleCardSkeleton />
      <SkeletonScanline />
    </SkeletonWrapper>
  );
};
